import ResponsiveDialog from '@/components/ResponsiveDialog';
import SeatSelectionContent from '@/components/purchase/checkout/seat-selection/modal/SeatSelectionContent';
import { SeatSelectionFooter } from '@/components/purchase/checkout/seat-selection/modal/SeatSelectionFooter';
import { useSeatSelection } from '@/hooks/useSeatSelection';
import { TransText } from '@/i18n/trans/text';
import type { FC } from 'react';

interface SeatSelectionModalProps {}

const SeatSelectionModal: FC<SeatSelectionModalProps> = () => {
  const { selectedReservationId, closeModal, isUndoing } = useSeatSelection();

  const handleOpenChange = (open: boolean) => {
    if (!open) {
      closeModal();
    }
  };

  return (
    <ResponsiveDialog
      open={Boolean(selectedReservationId)}
      onOpenChange={handleOpenChange}
      loading={isUndoing}
      title={<TransText i18nKey="seatSelection" />}
      content={<SeatSelectionContent />}
      footer={<SeatSelectionFooter />}
    />
  );
};

export default SeatSelectionModal;
